import { render, staticRenderFns } from "./setVipTag.vue?vue&type=template&id=d28b87ac&scoped=true&"
import script from "./setVipTag.vue?vue&type=script&lang=js&"
export * from "./setVipTag.vue?vue&type=script&lang=js&"
import style0 from "./setVipTag.vue?vue&type=style&index=0&id=d28b87ac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28b87ac",
  null
  
)

export default component.exports